module.exports = __webpack_public_path__ + "static/Лицензия_Банка_России_№3538_от_12 апреля-e46b730f527d51223e784ee60369851e.pdf";